// IP 기반 위치 감지 유틸리티

export interface LocationInfo {
  country: string;
  countryCode: string;
  region?: string;
  city?: string;
}

// 무료 IP 위치 감지 API 사용 (ipapi.co)
export async function detectUserLocation(): Promise<LocationInfo | null> {
  try {
    const response = await fetch("https://ipapi.co/json/");
    if (!response.ok) {
      throw new Error("Failed to fetch location");
    }

    const data = await response.json();

    return {
      country: data.country_name,
      countryCode: data.country_code,
      region: data.region,
      city: data.city,
    };
  } catch (error) {
    console.warn("Location detection failed:", error);
    return null;
  }
}

// 한국 관련 국가 코드들
export const KOREAN_COUNTRY_CODES = ["KR", "KP"];

// 위치 기반 언어 감지
export function getLanguageFromLocation(location: LocationInfo): "ko" | "en" {
  if (KOREAN_COUNTRY_CODES.includes(location.countryCode)) {
    return "ko";
  }
  return "en";
}
